export const COOKIE_KEYS = {
  USER_PREFERRED_LANGUAGE: 'complianceUPL',
  USER_NONCE: 'complianceUserNonce',
} as const;
